import { Link } from "@tanstack/react-router";
import logoSrc from "@/assets/logo.png";

export function SubizaLogo({ className = "", showTagline = true }) {
  return (
    <Link to="/" className={`inline-flex items-center gap-3 ${className}`}>
      <span className="subiza-logo__mark">
        <img src={logoSrc} alt="Subiza" className="h-12 w-auto sm:h-14" loading="eager" />
      </span>
      {showTagline && (
        <span className="hidden md:inline text-base sm:text-lg font-extrabold tracking-tight leading-tight text-text">
          Quizzes that{" "}
          <span className="bg-accent text-accent-foreground px-1.5 rounded">turn classrooms</span>{" "}
          into game shows.
        </span>
      )}
    </Link>
  );
}
